import { memo } from 'react'
import cn from 'classnames'

import { Avatar } from '@shared'

import styles from './SquadListItemDefault.module.scss'

interface SquadListItemDefaultProps {
  rank: number
  name: string
  score: number
  avatarUrl: string
  effectUrl: string
  groupColorIndex?: number | null
  isFirstInGroup?: boolean
  isLastInGroup?: boolean
}

const formatScore = (score: number): string => {
  return new Intl.NumberFormat('en-US').format(score)
}

export const SquadListItemDefault = memo(function SquadListItemDefault({
  rank,
  name,
  score,
  avatarUrl,
  effectUrl,
  groupColorIndex,
  isFirstInGroup,
  isLastInGroup,
}: SquadListItemDefaultProps) {
  return (
    <div
      className={cn(styles.item, {
        [styles[`groupColor${groupColorIndex}`]]:
          groupColorIndex !== null && groupColorIndex !== undefined,
        [styles.firstInGroup]: isFirstInGroup,
        [styles.lastInGroup]: isLastInGroup,
      })}
    >
      <div className={styles.itemContent}>
        <div className={styles.rankSection}>
          <span className={styles.rank}>{rank}</span>
          <Avatar srcAvatar={avatarUrl} srcEffect={effectUrl} className={styles.avatarContainer} eager={false} />
          <span className={styles.name}>{name}</span>
        </div>
        <div className={styles.scoreSection}>
          <span className={styles.score}>{formatScore(score)} $NOT</span>
        </div>
      </div>
    </div>
  )
})
